var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("电费汇总统计分析报表")])
}
var staticRenderFns = []

export { render, staticRenderFns }